import { useEffect, useState } from "react";
import { getPlanList, getPersonelTask, postPersonelTask , getPersonelComeToWork, deletePlan, deletePlanPersonel, getPlanSokakList, addPlanSokak, deletePlanSokak} from "../services/addressService";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import "../styles/pages/_route-plans.scss";// genellikle index.js veya App.js üstüne
import 'primereact/resources/themes/lara-light-blue/theme.css';  // veya başka bir tema
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { getAllPersonelUsers,getuserTask } from "../services/userService";
export default function RoutePlans() {
    const [planList, setPlanList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedPersonnel, setSelectedPersonnel] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentPlanId, setCurrentPlanId] = useState(null);
    const [currentPlanId2, setCurrentPlanId2] = useState(null);
    const [currentPersonnelId, setCurrentPersonnelId] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [personnelTasks, setPersonnelTasks] = useState([]);
    const [personnelWorks, setPersonnelWorks] = useState([]);
    const [selectedTasks, setSelectedTasks] = useState([]);
    const [taskSearch, setTaskSearch] = useState("");
    // Görev listesi modalının yükleme durumu: modal isteği beklemeden açılıyor.
    const [taskLoading, setTaskLoading] = useState(false);
    const [taskError, setTaskError] = useState(null);
    const [users, setUsers] = useState([]);
    // Sokak yönetimi modalı: plandaki sokakları personel bazında ekler/siler.
    const [showSokakModal, setShowSokakModal] = useState(false);
    const [sokakPlanId, setSokakPlanId] = useState(null);
    const [sokakData, setSokakData] = useState(null);
    const [sokakLoading, setSokakLoading] = useState(false);
    const [sokakIslemde, setSokakIslemde] = useState(false);
    const [seciliPlanSokaklari, setSeciliPlanSokaklari] = useState([]);
    const [seciliYeniSokaklar, setSeciliYeniSokaklar] = useState([]);
    const [seciliSokakPersonelleri, setSeciliSokakPersonelleri] = useState([]);
    const [yeniSokakArama, setYeniSokakArama] = useState("");
    // Plan satırı açılınca gösterilen sokak kırılımı. Plan başına bir kez çekilir.
    // expandedRows DİZİ tutulur: PrimeReact gruplama açıkken (groupRowsBy ile dataKey farklı)
    // açık satırları dizi olarak üretiyor ve sonraki tıklamada mevcut değeri diziymiş gibi
    // kopyalıyor — nesne verilirse ikinci tıklamada patlıyor.
    const [expandedRows, setExpandedRows] = useState([]);
    const [planKirilimlari, setPlanKirilimlari] = useState({});
    const fetchUsers = async () => {
        try {
          const response = await getAllPersonelUsers();
          // Ensure response is an array
          const usersArray = Array.isArray(response) ? response : [];
          setUsers(usersArray);
        }
        catch (error) {
          console.error("Failed to fetch users:", error);
          setUsers([]);
        }
      }; 
      const fetchComeToWorkUsers = async () => {
        try {
          const response = await getPersonelComeToWork();
          setPersonnelWorks(response);
        }
        catch (error) {
          console.error("Failed to fetch users:", error);
        }
      };
    useEffect(() => {
        const fetchPlanList = async () => {
            setLoading(true);
            try {
                const res = await getPlanList();
                const sorted = res.data.slice().sort((a, b) => new Date(b.tarih) - new Date(a.tarih));
                setPlanList(sorted);
            } catch (err) {
                setError("Plan listesi alınamadı");
            } finally {
                setLoading(false);
            }
        }
        fetchPlanList();   fetchComeToWorkUsers(); fetchUsers(); 
    }, []);

    const ExportUserTask = async (planid) => {
        try {
          const response = await getuserTask( { planid }  );
          const blob = response.data;
          // Dosya oluşturma ve indirme işlemi
          const url = window.URL.createObjectURL(blob); 
          const link = document.createElement("a");
          const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
          link.href = url;
          link.download = `gorevler-${today}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Failed to download full report:", error);
          setError("Rapor indirme işlemi başarısız oldu");
        } finally {
 
        }
      }
      const gunFilterTemplate = (options) => {
        return (
          <Dropdown
            value={options.value}
            options={days.map(day => ({ label: day, value: day }))}
            onChange={(e) => options.filterApplyCallback(e.value)} // ✅ burada düzeltildi
            placeholder="Gün Seçiniz"
            className="p-column-filter"
            showClear
          />
        );
      };
      
      const days = [
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi",
        "Pazar"
      ];
    const gorevler = Array.isArray(personnelTasks) ? personnelTasks : [];

    // Türkçe karakterlerde "I/İ" doğru eşleşsin diye tr-TR ile küçültüyoruz.
    const aramaMetni = (value) => (value ?? "").toString().toLocaleLowerCase("tr-TR");

    const ARANAN_ALANLAR = [
        "id", "ilce", "mah", "sokak", "apartman", "kapino",
        "islemYapanPersonel", "islemTarihi", "islemSaati"
    ];

    // Boşlukla ayrılan her kelime ayrı ayrı aranıyor: "1234 sok 5" gibi
    // parçalı yazımlar da eşleşsin.
    const aramaKelimeleri = aramaMetni(taskSearch).trim().split(/\s+/).filter(Boolean);

    const filtrelenmisGorevler = aramaKelimeleri.length === 0
        ? gorevler
        : gorevler.filter(task => {
            const satirMetni = aramaMetni(ARANAN_ALANLAR.map(alan => task[alan]).join(" "));
            return aramaKelimeleri.every(kelime => satirMetni.includes(kelime));
        });

    // PrimeReact DataTable satır hücrelerini memoize ediyor: seçim durumu satır
    // verisinin parçası olmadığı sürece tıklanan kutu ekranda tiklenmiş görünmüyor.
    // Bu yüzden seçimi satıra gömüp tabloyu bu türetilmiş listeyle besliyoruz.
    const tableRows = filtrelenmisGorevler.map(task => ({
        ...task,
        secili: selectedTasks.some(s => s.id === task.id)
    }));

    const checkboxBody = (row) => (
        <input
            type="checkbox"
            className="task-checkbox"
            checked={row.secili}
            onChange={(e) => {
                if (e.target.checked) {
                    setSelectedTasks([...selectedTasks, row]);
                } else {
                    setSelectedTasks(selectedTasks.filter(task => task.id !== row.id));
                }
            }}
        />
    );

    // NeighborhoodPlan.Sokaklar virgüllü bir ETİKET alanıdır; mükerrer/boş parça içerebiliyor.
    const planSokakAdlari = (row) => [
        ...new Set((row.sokaklar || "").split(",").map(s => s.trim()).filter(Boolean))
    ].sort((a, b) => a.localeCompare(b, "tr"));

    // Sokak adları kısaltılmıyor: bir plandaki tüm sokaklar etiket olarak alt alta sarmalanır
    // (155 sokaklı planlar var; kesilen metin hangi sokakların planda olduğunu göstermiyordu).
    // Sokak ekle/sil modalı yine bu hücreden açılır; sokak yönetimi plan satırının doğal yeri.
    const sokaklarBody = (row) => {
        const sokakAdlari = planSokakAdlari(row);
        // Etiket alanı bayatlayabiliyor (görevi olmayan sokak etiketi kalabiliyor). Satırın kırılımı
        // açılmışsa tek doğru kaynak olan RoutePlan ile karşılaştırıp bu sokakları işaretliyoruz.
        // Karşılaştırma normalize ediliyor: iki taraf aynı kaynaktan yazılıyor ama tek bir yazım
        // farkı bütün etiketleri "görevsiz" göstererek yanlış tablo çizerdi.
        // Kırılımı boş dönen plan (hiç görev yok) işaretlenmiyor: kırılım paneli bunu zaten söylüyor.
        const kirilim = planKirilimlari[row.id];
        const sokakAnahtari = (ad) => (ad || "").trim().toLocaleUpperCase("tr-TR");
        const gorevliSokaklar = kirilim?.sokaklar?.length
            ? new Set(kirilim.sokaklar.map(s => sokakAnahtari(s.sokak)))
            : null;

        return (
            <div className="route-plans-sokak-hucresi">
                {sokakAdlari.length === 0 ? (
                    <span className="route-plans-sokak-yok">Sokak yok</span>
                ) : (
                    <div className="route-plans-sokak-etiketleri">
                        {sokakAdlari.map((ad, index) => {
                            const gorevsiz = gorevliSokaklar !== null && !gorevliSokaklar.has(sokakAnahtari(ad));
                            return (
                                <span
                                    key={`${ad}-${index}`}
                                    className={`route-plans-sokak-etiketi${gorevsiz ? " gorevsiz" : ""}`}
                                    title={gorevsiz ? `${ad}: bu sokakta plana ait görev yok` : ad}
                                >
                                    {ad}
                                </span>
                            );
                        })}
                    </div>
                )}
                <Button
                    label={`Sokak ekle / sil (${sokakAdlari.length})`}
                    title="Sokak ekle / sil"
                    icon="pi pi-directions"
                    className="p-button-sm p-button-text route-plans-sokak-button"
                    onClick={() => openSokakModal(row)}
                />
            </div>
        );
    };

    // ---------------- İlçe kırılımı (grup başlığı) ----------------

    // Başlık her satırda yeniden hesaplanmasın diye ilçe özetleri bir kez türetiliyor.
    // Sayılar plan listesinin tamamına aittir, o an görüntülenen sayfaya değil.
    const ilceOzetleri = planList.reduce((ozet, plan) => {
        const anahtar = plan.ilce || "";
        if (!ozet[anahtar]) {
            ozet[anahtar] = { planAdedi: 0, mahalleler: new Set(), personeller: new Set() };
        }
        ozet[anahtar].planAdedi += 1;
        if (plan.mahalle) {
            ozet[anahtar].mahalleler.add(plan.mahalle);
        }
        (plan.personeller || "").split(",").map(x => x.trim()).filter(Boolean)
            .forEach(x => ozet[anahtar].personeller.add(x));
        return ozet;
    }, {});

    const ilceGrupBasligi = (row) => {
        const ozet = ilceOzetleri[row.ilce || ""];
        return (
            <div className="route-plans-grup-basligi">
                <span className="route-plans-grup-ilce">{row.ilce || "İlçe belirtilmemiş"}</span>
                {ozet && (
                    <span className="route-plans-grup-ozet">
                        {ozet.planAdedi} plan · {ozet.mahalleler.size} mahalle · {ozet.personeller.size} personel
                    </span>
                )}
            </div>
        );
    };

    // ---------------- Sokak kırılımı (satır açılınca) ----------------

    // Kırılım görev listesi ucundan (TaskToNewPersonel, PersonelId=0) türetiliyor: planın tek doğru
    // kaynağı RoutePlan satırlarıdır ve bu uç satır başına BUGÜNE ait işlemi de getirdiği için
    // sokak bazlı tamamlanma ek bir API değişikliği gerektirmiyor. Sayılar "Görev Listesi"
    // modalıyla aynı temele oturur (bloklu haneler süzülmüş, işlem = bugünün işlemi).
    const sokakKirilimiOlustur = (gorevler) => {
        const harita = new Map();

        (Array.isArray(gorevler) ? gorevler : []).forEach(gorev => {
            const sokak = (gorev.sokak || "").trim() || "(Sokak bilgisi yok)";
            if (!harita.has(sokak)) {
                harita.set(sokak, {
                    sokak,
                    haneler: new Set(),
                    gorevAdedi: 0,
                    tamamlanan: 0,
                    personeller: new Map()
                });
            }
            const kayit = harita.get(sokak);
            // Aynı hane birden fazla personele atanabiliyor: görev adedi satır sayısı,
            // hane adedi ise tekil kapı sayısıdır.
            kayit.haneler.add(`${gorev.apartman ?? ""}|${gorev.kapino ?? ""}`);
            kayit.gorevAdedi += 1;

            const yapildi = !!gorev.islemTarihi;
            if (yapildi) {
                kayit.tamamlanan += 1;
            }

            if (!kayit.personeller.has(gorev.personelId)) {
                kayit.personeller.set(gorev.personelId, {
                    id: gorev.personelId,
                    yedekAd: gorev.personelAdSoyad,
                    gorevAdedi: 0,
                    tamamlanan: 0
                });
            }
            const personel = kayit.personeller.get(gorev.personelId);
            personel.gorevAdedi += 1;
            if (yapildi) {
                personel.tamamlanan += 1;
            }
        });

        return [...harita.values()]
            .map(kayit => ({
                sokak: kayit.sokak,
                haneAdedi: kayit.haneler.size,
                gorevAdedi: kayit.gorevAdedi,
                tamamlanan: kayit.tamamlanan,
                oran: kayit.gorevAdedi > 0 ? Math.round((kayit.tamamlanan / kayit.gorevAdedi) * 100) : 0,
                personeller: [...kayit.personeller.values()].sort((a, b) => b.gorevAdedi - a.gorevAdedi)
            }))
            .sort((a, b) => a.sokak.localeCompare(b.sokak, "tr"));
    };

    const fetchPlanKirilimi = async (planId) => {
        setPlanKirilimlari(prev => ({ ...prev, [planId]: { yukleniyor: true } }));
        try {
            const res = await getPersonelTask(planId, 0);
            setPlanKirilimlari(prev => ({
                ...prev,
                [planId]: { yukleniyor: false, sokaklar: sokakKirilimiOlustur(res.data) }
            }));
        } catch (err) {
            console.error("Failed to fetch plan street breakdown:", err);
            setPlanKirilimlari(prev => ({
                ...prev,
                [planId]: { yukleniyor: false, hata: "Sokak kırılımı alınamadı" }
            }));
        }
    };

    // Açılan plan bir kez çekilir; satır kapanıp yeniden açıldığında tekrar istek atılmaz.
    const handleRowToggle = (e) => {
        const acikSatirlar = Array.isArray(e.data) ? e.data : [];
        setExpandedRows(acikSatirlar);
        acikSatirlar.forEach(satir => {
            if (!planKirilimlari[satir.id]) {
                fetchPlanKirilimi(satir.id);
            }
        });
    };

    // Personel adı canlı kullanıcı listesinden okunur: RoutePlan.PersonelAdSoyad plan kurulduğu
    // andaki anlık görüntü ve bayatlıyor, yalnızca yedek olarak kullanılır.
    const kirilimPersonelAdi = (personel) => {
        const user = users.find(u => u.id === personel.id);
        return user?.adSoyad || personel.yedekAd || `#${personel.id}`;
    };

    const kirilimPersonelBody = (row) => (
        <div className="sokak-personel-listesi">
            {row.personeller.map(personel => (
                <span key={personel.id} className="sokak-personel-etiketi">
                    {kirilimPersonelAdi(personel)} ({personel.tamamlanan}/{personel.gorevAdedi})
                </span>
            ))}
        </div>
    );

    const kirilimOranBody = (row) => {
        const sinif = row.oran >= 100 ? "tamam" : (row.oran > 0 ? "kismi" : "");
        return (
            <span className={`kirilim-oran ${sinif}`}>
                {row.tamamlanan} / {row.gorevAdedi} (%{row.oran})
            </span>
        );
    };

    const planKirilimTemplate = (row) => {
        const kirilim = planKirilimlari[row.id];

        if (!kirilim || kirilim.yukleniyor) {
            return <div className="plan-kirilim-bilgi">Sokak kırılımı yükleniyor...</div>;
        }
        if (kirilim.hata) {
            return <div className="plan-kirilim-bilgi">{kirilim.hata}</div>;
        }

        const sokaklar = kirilim.sokaklar || [];
        if (sokaklar.length === 0) {
            return <div className="plan-kirilim-bilgi">Bu planda görev bulunmuyor.</div>;
        }

        const toplamHane = sokaklar.reduce((toplam, s) => toplam + s.haneAdedi, 0);
        const toplamGorev = sokaklar.reduce((toplam, s) => toplam + s.gorevAdedi, 0);
        const toplamAlinan = sokaklar.reduce((toplam, s) => toplam + s.tamamlanan, 0);
        const oran = toplamGorev > 0 ? Math.round((toplamAlinan / toplamGorev) * 100) : 0;

        return (
            <div className="plan-kirilim">
                {/* Sayaçlar Görev Listesi modalıyla aynı temele oturuyor: BUGÜNE ait işlem. */}
                <div className="task-summary-info">
                    <span><strong>{row.ilce} / {row.mahalle}</strong> — {row.gun}</span>
                    <span className="summary-divider">|</span>
                    <span><strong>Sokak:</strong> {sokaklar.length}</span>
                    <span className="summary-divider">|</span>
                    <span><strong>Hane:</strong> {toplamHane}</span>
                    <span className="summary-divider">|</span>
                    <span><strong>Görev:</strong> {toplamGorev}</span>
                    <span className="summary-divider">|</span>
                    <span><strong>Bugün alınan:</strong> {toplamAlinan}</span>
                    <span className="summary-divider">|</span>
                    <span><strong>Tamamlanma:</strong> %{oran}</span>
                </div>
                <DataTable
                    value={sokaklar}
                    className="p-datatable-sm plan-kirilim-tablo"
                    scrollable
                    scrollHeight="360px"
                    emptyMessage="Sokak bulunamadı."
                >
                    <Column field="sokak" header="Sokak" sortable />
                    <Column field="haneAdedi" header="Hane" sortable style={{ width: "90px" }} />
                    <Column field="gorevAdedi" header="Görev" sortable style={{ width: "90px" }} />
                    <Column field="oran" header="Bugün Alınan" body={kirilimOranBody} sortable style={{ width: "180px" }} />
                    <Column header="Personeller" body={kirilimPersonelBody} />
                </DataTable>
            </div>
        );
    };

    const refreshPlanList = async () => {
        const res = await getPlanList();
        const sorted = res.data.slice().sort((a, b) => new Date(b.tarih) - new Date(a.tarih));
        setPlanList(sorted);

        // Sokak/personel değişikliğinden sonra açık kırılımlar bayat kalmasın: önbellek boşaltılıp
        // yalnızca ekranda açık olan planlar yeniden çekilir.
        const acikPlanIdleri = (expandedRows || []).map(satir => satir.id);
        setPlanKirilimlari({});
        await Promise.all(acikPlanIdleri.map(planId => fetchPlanKirilimi(planId)));
    };

    const  handlePersonnelClick = async (planId, personnelId) => {
        setCurrentPlanId(planId);
        setCurrentPersonnelId(personnelId);
        setTaskSearch("");
        setShowModal(true);
        // Önceki planın satırları temizlenmezse modal bir an eski listeyi gösteriyor.
        setPersonnelTasks([]);
        setTaskError(null);
        setTaskLoading(true);
        try {
            const res = await getPersonelTask(planId, personnelId);
            setPersonnelTasks(res.data);
        } catch (err) {
            console.error("Failed to fetch personnel tasks:", err);
            setError("Personel görevleri alınamadı");
            setTaskError("Görev listesi alınamadı. Lütfen tekrar deneyin.");
        } finally {
            setTaskLoading(false);
        }
    };
   
     const exportIcon = (row) => {
        if (!row.id) return "-"; 
                    return (
                        <Button  title="Excel olarak indir..."     icon="pi pi-file-excel"
                            key={row.id}
                            label={row.id}
                            className="p-button-sm p-button-outlined"
                            onClick={() => ExportUserTask(row.id)}
                        />
                    );
            
    };
    const personellerBody = (row) => {
        if (!row.personeller) return "-";
    
        // Users henüz gelmedi -> placeholder göster
        if (users.length === 0) {
            return (
                <div className="personnel-buttons">
                    {row.personeller.split(",").map((id) => (
                        <Button
                            key={id}
                            label="Yükleniyor..."
                            className="p-button-sm p-button-outlined"
                            disabled
                        />
                    ))}
                </div>
            );
        }
    
        // Personeller alanında mükerrer id gelebiliyor; her personel tek kez listelenmeli.
        const personnelIds = [...new Set(row.personeller.split(",").map(id => id.trim()).filter(Boolean))];

        return (
            <div className="personnel-buttons">
                {personnelIds.map((id) => {
                    const trimmedId = parseInt(id);
                    const user = users.find(user => user.id === trimmedId);
                    const label = user ? user.adSoyad : id;

                    const isWorked = Array.isArray(personnelWorks?.data) &&
                        personnelWorks.data.some(work => work.id === trimmedId);

                    return (
                        <span key={id} className="personnel-chip">
                            <Button
                                label={label}
                                style={{
                                    backgroundColor: isWorked ? "lightgreen" : "lightcoral",
                                    color: !isWorked ? "white" : "black"
                                }}
                                className="p-button-sm p-button-outlined"
                                onClick={() => handlePersonnelClick(row.id, trimmedId)}
                            />
                            <Button
                                icon="pi pi-times"
                                title={`${label} personelinin bu mahalledeki görevlerini sil`}
                                className="p-button-sm p-button-text p-button-danger personnel-remove-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handlePersonnelRemove(row, trimmedId, label);
                                }}
                            />
                        </span>
                    );
                })}
            </div>
        );
    };
    
    const gorevBody = (row) => {
        return (
          <div className="personnel-buttons">
            <Button
              key={0}
              label={'Listele'}
              className="p-button-sm p-button-outlined"
              onClick={() => handlePersonnelClick(row.id, 0)}
            />
          </div>
        );
      };

    const deleteBody = (row) => {
        return (
            <Button
                icon="pi pi-trash"
                className="p-button-danger p-button-outlined route-plans-delete-button"
                style={{ padding: '6px' }}
                onClick={() => handleDelete(row.id)}
            />
        );
    };
      
    // Tümünü-seç durumu ayrı state'te tutulmuyor, seçim listesinden türetiliyor:
    // aksi halde tek satır elle kaldırıldığında başlıktaki tik açık kalıyor ve
    // sonraki tıklama seçimi sıfırlıyordu.
    // Arama aktifken yalnızca ekranda görünen satırlar üzerinden çalışır;
    // aksi halde filtrelenip gizlenen haneler de farkında olmadan seçiliyordu.
    const allTasksSelected = filtrelenmisGorevler.length > 0 &&
        filtrelenmisGorevler.every(task => selectedTasks.some(s => s.id === task.id));

    const handleSelectAll = (e) => {
        const gorunenIdler = new Set(filtrelenmisGorevler.map(task => task.id));
        if (e.target.checked) {
            // Başka bir aramada yapılmış seçimler korunuyor.
            setSelectedTasks(prev => [
                ...prev,
                ...filtrelenmisGorevler.filter(task => !prev.some(s => s.id === task.id))
            ]);
        } else {
            setSelectedTasks(prev => prev.filter(task => !gorunenIdler.has(task.id)));
        }
    };

    const selectAllHeader = () => (
        <input
            type="checkbox"
            className="task-checkbox"
            checked={allTasksSelected}
            onChange={handleSelectAll}
            title="Tümünü Seç"
        />
    );
    const handleSave = async () => {
        try {
            if (!selectedUsers || (Array.isArray(selectedUsers) && selectedUsers.length === 0)) {
                alert("Önce personel seçiniz.");
                return;
            }
    
            const selectedTaskIds = selectedTasks.map(task => task.id).join(",");
            //alert(`${currentPlanId}-${currentPersonnelId}-${selectedUsers}-${selectedTaskIds}`);

            // Replace with your actual API call
            await postPersonelTask(selectedUsers, selectedTaskIds);
            setShowModal(false);
            setSelectedPersonnel(null);
            setSelectedTasks([]);
            // Optionally refresh plan list
            await refreshPlanList();
        } catch (err) {
            alert("Personel atama güncellenemedi");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Bu planı silmek istediğinizden emin misiniz?")) {
            return;
        }
        try {
            await deletePlan(id);
            // Refresh plan list after deletion
            await refreshPlanList();
        } catch (err) {
            console.error("Failed to delete plan:", err);
            alert("Plan silinirken bir hata oluştu");
        }
    };

    const handlePersonnelRemove = async (row, personnelId, label) => {
        const onay = `${label} personeli, ${row.ilce} / ${row.mahalle} (${row.gun}) planından çıkarılacak ve bu plandaki tüm görevleri silinecek. Onaylıyor musunuz?`;
        if (!window.confirm(onay)) {
            return;
        }
        try {
            await deletePlanPersonel(row.id, personnelId);
            await refreshPlanList();
        } catch (err) {
            console.error("Failed to delete plan personnel:", err);
            alert(err?.response?.data?.message || "Personel görevleri silinirken bir hata oluştu");
        }
    };

    // ---------------- Sokak ekle / sil ----------------

    const fetchSokakData = async (planId) => {
        setSokakLoading(true);
        try {
            const res = await getPlanSokakList(planId);
            setSokakData(res.data);
        } catch (err) {
            console.error("Failed to fetch plan streets:", err);
            setSokakData(null);
            alert(err?.response?.data?.message || "Sokak listesi alınamadı");
        } finally {
            setSokakLoading(false);
        }
    };

    const openSokakModal = async (row) => {
        setSokakPlanId(row.id);
        setSokakData(null);
        setSeciliPlanSokaklari([]);
        setSeciliYeniSokaklar([]);
        setSeciliSokakPersonelleri([]);
        setYeniSokakArama("");
        setShowSokakModal(true);
        await fetchSokakData(row.id);
    };

    const listedeDegistir = (liste, deger) =>
        liste.includes(deger) ? liste.filter(x => x !== deger) : [...liste, deger];

    // Plandaki personeller önce, plana dahil olmayan diğer personeller sonra:
    // yeni bir sokak yeni bir personele de atanabilsin.
    const sokakPersonelSecenekleri = (() => {
        const planPersonelleri = sokakData?.personeller || [];
        const planIdleri = new Set(planPersonelleri.map(p => p.id));
        const digerleri = users
            .filter(u => !planIdleri.has(u.id))
            .map(u => ({ id: u.id, adSoyad: u.adSoyad, gorevAdedi: 0, planDisi: true }));
        return [...planPersonelleri, ...digerleri];
    })();

    const seciliPersonelAdlari = () => sokakPersonelSecenekleri
        .filter(p => seciliSokakPersonelleri.includes(p.id))
        .map(p => p.adSoyad);

    // Seçim satır verisine gömülüyor (PrimeReact hücre memoizasyonu).
    const planSokakRows = (sokakData?.planSokaklari || []).map(s => ({
        ...s,
        secili: seciliPlanSokaklari.includes(s.sokak)
    }));

    const yeniSokakRows = (sokakData?.eklenebilirSokaklar || [])
        .filter(s => {
            const kelimeler = aramaMetni(yeniSokakArama).trim().split(/\s+/).filter(Boolean);
            if (kelimeler.length === 0) return true;
            const metin = aramaMetni(s.sokak);
            return kelimeler.every(k => metin.includes(k));
        })
        .map(s => ({
            ...s,
            secili: seciliYeniSokaklar.includes(s.sokak)
        }));

    const handleSokakAta = async () => {
        if (seciliYeniSokaklar.length === 0) {
            alert("Atanacak sokak seçiniz.");
            return;
        }
        if (seciliSokakPersonelleri.length === 0) {
            alert("Sokakların atanacağı personeli seçiniz.");
            return;
        }

        const haneAdedi = (sokakData?.eklenebilirSokaklar || [])
            .filter(s => seciliYeniSokaklar.includes(s.sokak))
            .reduce((toplam, s) => toplam + (s.haneAdedi || 0), 0);

        const tahminiGorev = haneAdedi * seciliSokakPersonelleri.length;
        const onay = `${seciliYeniSokaklar.join(", ")}\n\n`
            + `sokakları şu personele atanacak: ${seciliPersonelAdlari().join(", ")}\n\n`
            + `Yaklaşık ${tahminiGorev} görev oluşturulacak.`
            // Tek istekte on binlerce görev yazmak uzun sürüyor; operatör baştan görsün.
            + (tahminiGorev > 5000 ? "\n\nDİKKAT: Bu kadar görevin yazılması uzun sürebilir." : "")
            + "\n\nOnaylıyor musunuz?";
        if (!window.confirm(onay)) {
            return;
        }

        setSokakIslemde(true);
        try {
            const res = await addPlanSokak(sokakPlanId, seciliYeniSokaklar, seciliSokakPersonelleri);
            const d = res.data || {};
            let mesaj = `${d.eklenenGorevAdedi ?? 0} görev eklendi.`;
            if (d.atlananMevcutGorevAdedi > 0) {
                mesaj += ` ${d.atlananMevcutGorevAdedi} görev zaten mevcut olduğu için atlandı.`;
            }
            if (d.haneBulunmayanSokaklar?.length > 0) {
                mesaj += ` Hanesi bulunmayan sokaklar: ${d.haneBulunmayanSokaklar.join(", ")}.`;
            }
            alert(mesaj);
            setSeciliYeniSokaklar([]);
            await fetchSokakData(sokakPlanId);
            await refreshPlanList();
        } catch (err) {
            console.error("Failed to add plan streets:", err);
            alert(err?.response?.data?.message || "Sokak atama işlemi başarısız oldu");
        } finally {
            setSokakIslemde(false);
        }
    };

    const handleSokakSil = async () => {
        if (seciliPlanSokaklari.length === 0) {
            alert("Silinecek sokak seçiniz.");
            return;
        }

        const tumPersonelden = seciliSokakPersonelleri.length === 0;
        const onay = `${seciliPlanSokaklari.join(", ")}\n\n`
            + (tumPersonelden
                ? "sokakları TÜM personellerden silinecek ve bu sokaklara ait görevler kaldırılacak.\n\n"
                : `sokakları şu personelden silinecek: ${seciliPersonelAdlari().join(", ")}\n\n`)
            + "Onaylıyor musunuz?";
        if (!window.confirm(onay)) {
            return;
        }

        setSokakIslemde(true);
        try {
            const res = await deletePlanSokak(sokakPlanId, seciliPlanSokaklari, seciliSokakPersonelleri);
            const d = res.data || {};
            let mesaj = `${d.silinenGorevAdedi ?? 0} görev silindi.`;
            if (d.planlanDusenSokaklar?.length > 0) {
                mesaj += ` Plandan çıkan sokaklar: ${d.planlanDusenSokaklar.join(", ")}.`;
            }
            if (d.planlanDusenPersoneller?.length > 0) {
                mesaj += ` Görevi kalmadığı için plandan çıkan personel id'leri: ${d.planlanDusenPersoneller.join(", ")}.`;
            }
            alert(mesaj);
            setSeciliPlanSokaklari([]);
            await fetchSokakData(sokakPlanId);
            await refreshPlanList();
        } catch (err) {
            console.error("Failed to delete plan streets:", err);
            alert(err?.response?.data?.message || "Sokak silme işlemi başarısız oldu");
        } finally {
            setSokakIslemde(false);
        }
    };

    const planSokakSecimBody = (row) => (
        <input
            type="checkbox"
            className="task-checkbox"
            checked={row.secili}
            onChange={() => setSeciliPlanSokaklari(prev => listedeDegistir(prev, row.sokak))}
        />
    );

    const yeniSokakSecimBody = (row) => (
        <input
            type="checkbox"
            className="task-checkbox"
            checked={row.secili}
            onChange={() => setSeciliYeniSokaklar(prev => listedeDegistir(prev, row.sokak))}
        />
    );

    const planSokakPersonelBody = (row) => (
        <div className="sokak-personel-listesi">
            {(row.personeller || []).map(p => (
                <span key={p.id} className="sokak-personel-etiketi">
                    {p.adSoyad} ({p.gorevAdedi})
                </span>
            ))}
        </div>
    );

    const tumPlanSokaklariSecili = planSokakRows.length > 0 && planSokakRows.every(s => s.secili);
    const tumYeniSokaklarSecili = yeniSokakRows.length > 0 && yeniSokakRows.every(s => s.secili);

    return (
        <div className="people-container neighborhood-container">
            <div className="fart">
             <h1 className="page-title">Bugün İşe Gelen Personeller</h1>
             <div className="comeToworks-grid">
                        {personnelWorks.data?.length > 0 ? (
                        personnelWorks.data.map((person, index) => (
                            <div key={index} className="person-card">
                            <div className="person-name">{person.adSoyad}</div>
                            </div>
                        ))
                        ) : (
                        <div className="no-personnel">Bugün işe gelen personel yok.</div>
                        )}
                    </div>                   
                    </div>
            <h1 className="page-title">Görev Planları</h1>
            {/* Liste iki kademeli kırılımlı: satırlar ilçe başlıkları altında toplanıyor, plan satırı
                açılınca o planın sokak kırılımı geliyor. sortField gruplama alanıyla aynı olduğu
                sürece PrimeReact başka bir sütuna tıklandığında da ilçeyi sıralamanın başında tutuyor,
                yani gruplar bozulmuyor. İlçe artık ayrı sütun değil, grup başlığında. */}
            <DataTable 
                key={users.length > 0 ? "users-loaded" : "users-loading"} 
                className="route-plans-table" 
                value={planList} 
                loading={loading} 
                paginator 
                rows={30} 
                stripedRows 
                responsiveLayout="scroll" 
                filterDisplay="row"
                dataKey="id"
                rowGroupMode="subheader"
                groupRowsBy="ilce"
                rowGroupHeaderTemplate={ilceGrupBasligi}
                sortMode="single"
                sortField="ilce"
                sortOrder={1}
                expandedRows={expandedRows}
                onRowToggle={handleRowToggle}
                rowExpansionTemplate={planKirilimTemplate}
            >
                <Column expander style={{ width: "3.5rem" }} />
                <Column field="id" header="ID" sortable body={exportIcon} />
                <Column field="mahalle" header="Mahalle" sortable />
                <Column 
                    field="gun" 
                    header="Gün" 
                    filter   showFilterMatchModes={false}
                    filterMatchMode="equals"   // ✅ Tam eşleşme
                    filterElement={gunFilterTemplate}
                    />
              
                <Column field="sokaklar" header="Sokaklar" body={sokaklarBody} />
                <Column 
                    field="personeller" 
                    header="Personeller" 
                    body={personellerBody} 
                />
                <Column field="personeller" header="Görev Listesi" body={gorevBody} />
                <Column header="İşlem" body={deleteBody} style={{ width: "80px" }} />
            </DataTable>

            {/* Görev listesi 10 sütuna çıktı; 850px genişlikte sütunlar okunmuyordu. */}
            <Dialog
               header={
                currentPersonnelId === 0 ? null : (
                  <div style={{  margin:'00px 0px 0px 20px',  fontSize:'1.3rem' }}>
                    Destek Personeli Atama
                  </div>
                )
              }
                visible={showModal}
                style={{ width: '100%', left:'auto', maxWidth:'1200px' ,height: '100%'}}
                onHide={() => setShowModal(false)}
            >
                <div className="p-fluid"  style={{  padding:'20px'}}>
                    
                {currentPersonnelId !== 0 && (
                        <div className="batch-assignment-group">
                        <select
                            value={selectedUsers}
                            onChange={(e) => setSelectedUsers(e.target.value)}
                            className="filter-input batch-group-select"
                        >
                            <option value="">Destek Personeli Seçiniz</option>
                            {users.map(user => (
                            <option key={user.id} value={user.id}>
                                {user.adSoyad}
                            </option>
                            ))}
                        </select>
                        </div>
                    )}

                        <div className="p-field"  style={{  marginTop:'20px'}}>
                        <div className="task-list-header">
                            <label style={{ fontSize:'1.3rem'}}>Görev Listesi</label>
                            <div className="task-search-box">
                                <i className="pi pi-search" />
                                <input
                                    type="text"
                                    className="task-search-input"
                                    value={taskSearch}
                                    onChange={(e) => setTaskSearch(e.target.value)}
                                    placeholder="Ara: sokak, apartman, hane, personel, tarih..."
                                />
                                {taskSearch && (
                                    <button
                                        type="button"
                                        className="task-search-clear"
                                        title="Aramayı temizle"
                                        onClick={() => setTaskSearch("")}
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>
                        </div>
                        {/* Liste gelene kadar özet ve tablo yerine yükleniyor bilgisi gösterilir:
                            modal isteği beklemeden açıldığı için boş tablo "hane bulunamadı" diyordu. */}
                        {taskLoading ? (
                            <div className="task-loading">
                                <i className="pi pi-spin pi-spinner" />
                                <span>Görev listesi yükleniyor...</span>
                            </div>
                        ) : taskError ? (
                            <div className="task-loading task-hata">
                                <i className="pi pi-exclamation-triangle" />
                                <span>{taskError}</span>
                            </div>
                        ) : (
                        <>
                        {/* Özet, arama sonucundaki satırlara göre hesaplanıyor:
                            ekranda görünen liste ile sayılar tutarlı kalsın. */}
                        {(() => {
                            const toplam = filtrelenmisGorevler.length;
                            // Sayaçlar Durum sütunuyla aynı temele oturuyor: BUGÜNE ait işlem.
                            // gidildiMi ile sayılırsa ekranda 2 tik görünürken "Alınan: 1616" yazıyordu
                            // (gidildiMi bir kez true olunca sıfırlanmıyor).
                            const alinan = filtrelenmisGorevler.filter(t => !!t.islemTarihi).length;
                            const alinmayan = toplam - alinan;
                            const oran = toplam > 0 ? Math.round((alinan / toplam) * 100) : 0;
                            return (
                                <div className="task-summary-info">
                                    <span><strong>Toplam Hane:</strong> {toplam}</span>
                                    <span className="summary-divider">|</span>
                                    <span><strong>Alınan:</strong> {alinan}</span>
                                    <span className="summary-divider">|</span>
                                    <span><strong>Alınmayan:</strong> {alinmayan}</span>
                                    <span className="summary-divider">|</span>
                                    <span><strong>Tamamlanma Oranı:</strong> %{oran}</span>
                                    {aramaKelimeleri.length > 0 && (
                                        <>
                                            <span className="summary-divider">|</span>
                                            <span className="summary-filtered">
                                                Arama sonucu: {toplam} / {gorevler.length} hane
                                            </span>
                                        </>
                                    )}
                                </div>
                            );
                        })()}
                        <DataTable
                              value={tableRows}
                              className="p-datatable-sm"
                              scrollable
                              emptyMessage="Aramanıza uygun hane bulunamadı."
                          >

                                {currentPersonnelId !== 0 && (
                                        <Column body={checkboxBody} header={selectAllHeader} style={{ width: "50px" }} />
                                        )}
                                <Column field="id" header="Id" />
                                <Column field="ilce" header="İlçe" />
                                <Column field="mah" header="Mahalle" />
                                <Column field="sokak" header="Sokak" />
                                <Column field="apartman" header="Apartman" />
                                <Column field="kapino" header="Hane" />
                                {/* İşlem alanlarını API yalnızca BUGÜNE ait işlemden dolduruyor
                                    (poşet verildi / atık alındı / ziyaret edildi). Personel adı ise
                                    yalnızca işlemi görevin atandığı personel yaptıysa geliyor;
                                    haneye başka bir personel uğradıysa isim boş, tarih/saat dolu kalır. */}
                                <Column field="islemYapanPersonel" header="İşlemi Yapan Personel" />
                                <Column field="islemTarihi" header="İşlem Tarihi" />
                                <Column field="islemSaati" header="İşlem Saati" />
                                <Column
                                      header="Durum"
                                      body={(data) => {
                                          // islemTarihi yalnızca BUGÜNE ait işlem varsa dolu gelir
                                          // (API tarafında süzülüyor). gidildiMi kullanılamaz: bir kez true
                                          // olduktan sonra sıfırlanmadığı için aylar önceki ziyaret de tik gösteriyordu.
                                          return data.islemTarihi ? (
                                              <span className="inline-flex items-center gap-1 text-sm font-medium text-green-800">
                                                  <span aria-hidden>✓</span>
                                              </span>
                                          ) : (
                                              <span className="inline-flex items-center gap-1 text-sm font-medium text-red-700" style={{ color: "#b91c1c" }}>
                                                  <span aria-hidden>✗</span>
                                              </span>
                                          );
                                      }}
                                  />
                                </DataTable>
                        </>
                        )}

                    </div>
                    {currentPersonnelId !== 0 && (
                            <Button
                            label="Kaydet"
                            className="p-button-success"
                            disabled={taskLoading}
                            onClick={handleSave}
                            />
                        )}
                </div>
            </Dialog>

            <Dialog
                header={
                    <div style={{ margin: '0px 0px 0px 20px', fontSize: '1.3rem' }}>
                        Sokak Yönetimi
                        {sokakData && ` — ${sokakData.ilce} / ${sokakData.mahalle} (${sokakData.gun})`}
                    </div>
                }
                visible={showSokakModal}
                style={{ width: '100%', left: 'auto', maxWidth: '1200px', height: '100%' }}
                onHide={() => setShowSokakModal(false)}
            >
                <div className="p-fluid" style={{ padding: '20px' }}>
                    {sokakLoading && <div className="sokak-bilgi">Sokak listesi yükleniyor...</div>}

                    {!sokakLoading && !sokakData && (
                        <div className="sokak-bilgi">Sokak listesi alınamadı.</div>
                    )}

                    {!sokakLoading && sokakData && (
                        <>
                            <div className="sokak-personel-secim">
                                <label style={{ fontSize: '1.1rem', fontWeight: 600 }}>Personeller</label>
                                {/* Tek personel seçimi iki işlemi de yönetiyor: atamada zorunlu,
                                    silmede boş bırakılırsa sokak tüm personellerden düşer. */}
                                <div className="sokak-bilgi">
                                    Atama için personel seçimi zorunludur. Silmede personel seçilmezse
                                    sokak <strong>tüm personellerden</strong> silinir.
                                </div>
                                <div className="sokak-personel-kutulari">
                                    {sokakPersonelSecenekleri.map(p => (
                                        <label
                                            key={p.id}
                                            className={`sokak-personel-kutusu${p.planDisi ? " plan-disi" : ""}`}
                                            title={p.planDisi ? "Bu personel planda yok; sokak atanırsa plana eklenir." : `Plandaki görev adedi: ${p.gorevAdedi}`}
                                        >
                                            <input
                                                type="checkbox"
                                                className="task-checkbox"
                                                checked={seciliSokakPersonelleri.includes(p.id)}
                                                onChange={() => setSeciliSokakPersonelleri(prev => listedeDegistir(prev, p.id))}
                                            />
                                            <span>{p.adSoyad}{p.planDisi ? "" : ` (${p.gorevAdedi})`}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            <div className="sokak-kolonlar">
                                <div className="sokak-kolon">
                                    <div className="sokak-kolon-baslik">
                                        <label style={{ fontSize: '1.1rem', fontWeight: 600 }}>
                                            Plandaki Sokaklar ({planSokakRows.length})
                                        </label>
                                        <Button
                                            label="Seçili Sokakları Sil"
                                            icon="pi pi-trash"
                                            className="p-button-sm p-button-danger"
                                            disabled={sokakIslemde || seciliPlanSokaklari.length === 0}
                                            onClick={handleSokakSil}
                                        />
                                    </div>
                                    <DataTable
                                        value={planSokakRows}
                                        className="p-datatable-sm"
                                        scrollable
                                        scrollHeight="420px"
                                        emptyMessage="Planda görevi olan sokak yok."
                                    >
                                        <Column
                                            style={{ width: "50px" }}
                                            body={planSokakSecimBody}
                                            header={() => (
                                                <input
                                                    type="checkbox"
                                                    className="task-checkbox"
                                                    title="Tümünü Seç"
                                                    checked={tumPlanSokaklariSecili}
                                                    onChange={(e) => setSeciliPlanSokaklari(
                                                        e.target.checked ? planSokakRows.map(s => s.sokak) : []
                                                    )}
                                                />
                                            )}
                                        />
                                        <Column field="sokak" header="Sokak" />
                                        <Column field="haneAdedi" header="Hane" style={{ width: "70px" }} />
                                        <Column field="gorevAdedi" header="Görev" style={{ width: "70px" }} />
                                        <Column header="Personeller" body={planSokakPersonelBody} />
                                    </DataTable>
                                </div>

                                <div className="sokak-kolon">
                                    <div className="sokak-kolon-baslik">
                                        <label style={{ fontSize: '1.1rem', fontWeight: 600 }}>
                                            Eklenebilir Sokaklar ({yeniSokakRows.length})
                                        </label>
                                        <Button
                                            label="Seçili Sokakları Ata"
                                            icon="pi pi-plus"
                                            className="p-button-sm p-button-success"
                                            disabled={sokakIslemde || seciliYeniSokaklar.length === 0}
                                            onClick={handleSokakAta}
                                        />
                                    </div>
                                    <div className="task-search-box" style={{ marginBottom: '8px' }}>
                                        <i className="pi pi-search" />
                                        <input
                                            type="text"
                                            className="task-search-input"
                                            value={yeniSokakArama}
                                            onChange={(e) => setYeniSokakArama(e.target.value)}
                                            placeholder="Sokak ara..."
                                        />
                                        {yeniSokakArama && (
                                            <button
                                                type="button"
                                                className="task-search-clear"
                                                title="Aramayı temizle"
                                                onClick={() => setYeniSokakArama("")}
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>
                                    <DataTable
                                        value={yeniSokakRows}
                                        className="p-datatable-sm"
                                        scrollable
                                        scrollHeight="380px"
                                        emptyMessage="Eklenebilecek sokak bulunamadı."
                                    >
                                        <Column
                                            style={{ width: "50px" }}
                                            body={yeniSokakSecimBody}
                                            header={() => (
                                                <input
                                                    type="checkbox"
                                                    className="task-checkbox"
                                                    title="Tümünü Seç"
                                                    checked={tumYeniSokaklarSecili}
                                                    onChange={(e) => setSeciliYeniSokaklar(
                                                        e.target.checked ? yeniSokakRows.map(s => s.sokak) : []
                                                    )}
                                                />
                                            )}
                                        />
                                        <Column field="sokak" header="Sokak" />
                                        <Column field="haneAdedi" header="Hane" style={{ width: "70px" }} />
                                    </DataTable>
                                </div>
                            </div>

                            {sokakIslemde && <div className="sokak-bilgi">İşlem sürüyor, lütfen bekleyin...</div>}
                        </>
                    )}
                </div>
            </Dialog>
            <style jsx>{`.personnel-buttons {
                        max-width: 400px;
                    }
                        svg.p-icon.p-dropdown-clear-icon.p-clickable {
                    margin-top: -8px;
                }
                        .route-plans-sokak-button {
                            text-align: left;
                            padding: 2px 6px;
                            white-space: normal;
                        }
                        .sokak-bilgi {
                            margin: 8px 0;
                            padding: 8px 12px;
                            background: #f1f5f9;
                            border: 1px solid #e2e8f0;
                            border-radius: 6px;
                            font-size: 0.9rem;
                            color: #334155;
                        }
                        .sokak-personel-kutulari {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;
                            margin: 8px 0 4px 0;
                            max-height: 140px;
                            overflow-y: auto;
                        }
                        .sokak-personel-kutusu {
                            display: flex;
                            align-items: center;
                            gap: 6px;
                            padding: 4px 10px;
                            border: 1px solid #cbd5e1;
                            border-radius: 20px;
                            font-size: 0.9rem;
                            cursor: pointer;
                            background: #fff;
                        }
                        .sokak-personel-kutusu.plan-disi {
                            border-style: dashed;
                            color: #64748b;
                        }
                        /* Modal 1200px'de iki liste yan yana sığıyor; daha darda alt alta iniyor. */
                        .sokak-kolonlar {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 20px;
                            margin-top: 16px;
                        }
                        .sokak-kolon {
                            flex: 1 1 420px;
                            min-width: 320px;
                        }
                        .sokak-kolon-baslik {
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            justify-content: space-between;
                            gap: 10px;
                            margin-bottom: 8px;
                        }
                        .sokak-personel-listesi {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 4px;
                        }
                        .sokak-personel-etiketi {
                            background: rgba(24, 150, 78, 0.15);
                            color: #18964e;
                            border-radius: 4px;
                            padding: 1px 6px;
                            font-size: 0.8rem;
                        }
                        .task-summary-info {
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            gap: 8px;
                            margin: 10px 0 16px 0;
                            padding: 10px 14px;
                            background: #f1f5f9;
                            border: 1px solid #e2e8f0;
                            border-radius: 6px;
                            font-size: 0.95rem;
                            color: #334155;
                        }
                        .task-summary-info .summary-divider {
                            color: #94a3b8;
                        }
                        .task-summary-info .summary-filtered {
                            color: #2563eb;
                            font-weight: 600;
                        }
                        .task-list-header {
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            justify-content: space-between;
                            gap: 12px;
                            margin: 20px 0 0 0;
                        }
                        .task-search-box {
                            position: relative;
                            display: flex;
                            align-items: center;
                            min-width: 320px;
                            flex: 0 1 380px;
                        }
                        .task-search-box .pi-search {
                            position: absolute;
                            left: 10px;
                            color: #94a3b8;
                            font-size: 0.9rem;
                            pointer-events: none;
                        }
                        .task-search-input {
                            width: 100%;
                            padding: 8px 30px 8px 32px;
                            border: 1px solid #cbd5e1;
                            border-radius: 6px;
                            font-size: 0.95rem;
                            outline: none;
                        }
                        .task-search-input:focus {
                            border-color: #2563eb;
                            box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
                        }
                        .task-search-clear {
                            position: absolute;
                            right: 8px;
                            border: none;
                            background: transparent;
                            color: #64748b;
                            cursor: pointer;
                            font-size: 0.85rem;
                            line-height: 1;
                            padding: 2px;
                        }
                        .task-search-clear:hover {
                            color: #b91c1c;
                        }
          span.p-column-title {
            color: white;
          }
            .p-datatable .p-datatable-tbody > tr > td {
                padding: 5px !important;
            }
                span.inline-flex.items-center.gap-1.text-sm.font-medium.text-green-800 {
    text-align: center;
    margin: auto;
    display: block;
}
              .p-column-header-content  .route-plans-table th svg {
                        color: #000; display:none;
                    }
.p-column-filter svg{
   color: #fff !important;
}
                    .comeToworks-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
}

.person-card {
         display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px !important;
    transition: background-color 0.2s ease;
    width: 209px;
    padding: 10px;
    justify-content: space-between;
    background: rgba(24, 150, 78, 0.2);
    color: #18964e;
}

.person-card:hover {
  transform: scale(1.03);
}

.person-name {
  font-weight: bold;
}

.person-button {
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
}

.person-button:hover {
  background-color: #357ABD;
}

.no-personnel {
  font-style: italic;
  color: #888;
}

      `}</style>
        </div>
    );
}